import React from 'react'
import { styled } from '@mui/material/styles'
import { slugify } from '@helpers/string-helper'
import { useTest } from '@hooks/useTest'
import { useBaseCollectionTileContext } from '../BaseCollectionTileContext'

const StyledTitle = styled('h2')(({ theme }) => ({
  fontSize: '23px',
  fontWeight: 600,
  lineHeight: 'normal',
  color: theme.palette.primary.dark,
  textTransform: 'none',
}))

const Title = () => {
  const { collection } = useBaseCollectionTileContext()
  const { title } = collection ?? {}
  const { generateTestId } = useTest()
  if (!title) {
    return null
  }

  return (
    <StyledTitle
      id={`collection-title-${slugify(collection?.title) || ''}`}
      data-testid={generateTestId('collection-tile', 'title')}
    >
      {title}
    </StyledTitle>
  )
}

export default Title
